import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Nav from "../NavBar/Nav";
import FooterNew from "../NavBar/FooterNew";
import { formatMoney } from "./experienceUtils";
import "./Experiences.css";

export default function ExperienceConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const snapshot = location.state;

  if (!snapshot) {
    return (
      <div className="exp-scope">
        <Nav />
        <div className="exp-confirm-wrap">
          <h1>Nothing to confirm yet</h1>
          <p>Looks like you navigated here directly. Start a search to book an experience.</p>
          <div className="exp-confirm-actions">
            <a className="exp-inline-btn" onClick={() => navigate("/experiences")}>
              Find experiences
            </a>
          </div>
        </div>
        <FooterNew />
      </div>
    );
  }

  const { items, subtotal, currency, form, reference } = snapshot;

  return (
    <div className="exp-scope">
      <div style={{ position: "relative" }}>
        <Nav />
      </div>

      <div className="exp-confirm-wrap">
        <div className="exp-confirm-icon">
          <CheckCircleOutlineIcon fontSize="large" />
        </div>
        <h1>Booking request received</h1>
        <p>
          Thanks, {form.fullName.split(" ")[0]}. We've received your request for{" "}
          {items.length} experience{items.length > 1 ? "s" : ""} totalling{" "}
          {formatMoney(subtotal, currency)}. Our team will confirm availability and email your
          vouchers to <strong>{form.email}</strong> shortly.
        </p>
        <div className="exp-confirm-ref">Booking reference: {reference}</div>
        <p>
          Keep this reference handy if you need to get in touch with us about this booking.
        </p>
        <div className="exp-confirm-actions">
          <a className="exp-inline-btn" onClick={() => navigate("/experiences")}>
            Browse more experiences
          </a>
          <a
            className="exp-btn-secondary"
            style={{ width: "auto", padding: "11px 26px", display: "inline-block" }}
            onClick={() => navigate("/")}
          >
            Back to home
          </a>
        </div>
      </div>

      <FooterNew />
    </div>
  );
}
